import ForceInteger from "./force-integer";

import InputCity from "./city/";
import InputCompanyAddress from "./input-company-address";
import InputCompanyCity from "./input-company-city";
import InputCompanyEmail from "./input-company-email";

import InputCompanyZipcode from "./input-company-zipcode";

import InputPassword from "./input-password";
import InputZip from "./zip/";
import InputDisplayName from "./display-name";
import InputUserRole from "./user-role/";
import InputUsername from "./username";
import InputMobile from "./mobile";
import InputEmail from "./email";
import InputName from "./name";
import InputAddress from "./address/";

import InputCompanyName from "./company-name";
import InputCompanyCvr from "./company-cvr";
import InputCompanyEan from "./company-ean";

import InputPspElement from "./psp-element";
import InputPspResponsible from "./psp-responsible";

import PwCheck from "./pw-check";

const modul = angular
    .module("InputFields", [])

    .directive("forceInteger", ForceInteger)
    .directive("inputAddress", InputAddress)
    .directive("inputPspElement", InputPspElement)
    .directive("inputPspResponsible", InputPspResponsible)

    .directive("inputCity", InputCity)
    .directive("inputCompanyAddress", InputCompanyAddress)
    .directive("inputCompanyCity", InputCompanyCity)
    .directive("inputCompanyEmail", InputCompanyEmail)
    .directive("inputCompanyName", InputCompanyName)
    .directive("inputCompanyZipcode", InputCompanyZipcode)
    .directive("inputCompanyCvr", InputCompanyCvr)
    .directive("inputCompanyEan", InputCompanyEan)
    .directive("inputEmail", InputEmail)
    .directive("inputName", InputName)
    .directive("inputPassword", InputPassword)
    .directive("inputMobile", InputMobile)
    .directive("inputUsername", InputUsername)
    .directive("inputUserRole", InputUserRole)
    .directive("inputZip", InputZip)
    .directive("inputDisplayName", InputDisplayName)
    .directive("pwCheck", PwCheck);

export default modul.name;
